package es.subastia.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuAnchorType
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.option_all

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun <T> FilterSelector(
    label: String,
    options: List<T>,
    selectedOption: T?,
    onOptionSelected: (T?) -> Unit,
    optionLabel: @Composable (T) -> String,
    allOptionLabel: String = stringResource(Res.string.option_all),
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }

    // Logic for displaying "Todas" or selected option
    val displayText = selectedOption?.let { optionLabel(it) } ?: allOptionLabel

    Box(modifier = modifier) {
        ExposedDropdownMenuBox(
            expanded = expanded,
            onExpandedChange = { expanded = it },
        ) {
            OutlinedTextField(
                modifier = Modifier.menuAnchor(ExposedDropdownMenuAnchorType.PrimaryNotEditable).fillMaxWidth(),
                readOnly = true,
                value = displayText,
                onValueChange = {},
                label = { Text(label) },
                trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expanded) },
                colors = ExposedDropdownMenuDefaults.outlinedTextFieldColors(),
            )
            ExposedDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
            ) {
                // Option for "Todas" (null)
                DropdownMenuItem(
                    text = { Text(allOptionLabel) },
                    onClick = {
                        onOptionSelected(null)
                        expanded = false
                    },
                    contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding,
                )

                options.forEach { option ->
                    DropdownMenuItem(
                        text = { Text(optionLabel(option)) },
                        onClick = {
                            onOptionSelected(option)
                            expanded = false
                        },
                        contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding,
                    )
                }
            }
        }
    }
}

@Preview
@Composable
fun FilterSelectorPreview() {
    MaterialTheme {
        FilterSelector(
            label = "Province",
            options = listOf("Madrid", "Barcelona", "Valencia"),
            selectedOption = "Madrid",
            onOptionSelected = {},
            optionLabel = { it },
        )
    }
}
